import { createContextManager, isEmptyObject, storeContextManager } from '@datadog/browser-core';
import { SKIPPED } from '../../hooks';
export function startAccountContext(hooks, configuration) {
    const accountContextManager = buildAccountContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, accountContextManager, 'rum', 4 /* CustomerDataType.Account */);
    }
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        const account = accountContextManager.getContext();
        if (isEmptyObject(account) || !account.id) {
            return SKIPPED;
        }
        return {
            type: eventType,
            account,
        };
    });
    return accountContextManager;
}
export function buildAccountContextManager() {
    return createContextManager('account', {
        propertiesConfig: {
            id: { type: 'string', required: true },
            name: { type: 'string' },
        },
    });
}
//# sourceMappingURL=accountContext.js.map